import { useTranslate } from "@similarweb/i18n-provider";
import { Check, SocialEmail } from "@similarweb/icons";
import { colorsPalettes } from "@similarweb/styles";
import { Button, Tooltip } from "@similarweb/ui-components";
import { Text } from "@similarweb/ui-components/foundations";

import { TABS_ARRAY } from "app/pages/activation/modules/Settings/config";
import { SettingsTabs } from "app/pages/activation/modules/Settings/types";
import {
    ACTIVATION_SETTINGS_ROUTE,
    DEFAULT_ACTIVATION_GRANULARITY,
    DEFAULT_ACTIVATION_WEB_SOURCE,
} from "app/pages/activation/routing/constants";
import { useActivationSet } from "app/pages/activation-alerts/hooks/useActivationSet";
import { proNavigator } from "single-spa/react-app/ProNavigator";

import { useSubscribeButton } from "./useSubscribeButton";

export const SubscribeButton = () => {
    const { translate } = useTranslate();
    const { activationSet } = useActivationSet();
    const { activationId, isSubscribed, isButtonDisabled, subscribe } = useSubscribeButton();

    const handleClick = async () => {
        if (isSubscribed) {
            await proNavigator.go(ACTIVATION_SETTINGS_ROUTE, {
                key: activationId,
                country: activationSet?.country,
                webSource: DEFAULT_ACTIVATION_WEB_SOURCE,
                timeGranularity: DEFAULT_ACTIVATION_GRANULARITY,
                domain: activationSet?.primaryDomain,
                tab: TABS_ARRAY.indexOf(SettingsTabs.Subscriptions),
                scrollToAlerts: true,
            });
        } else {
            subscribe();
        }
    };

    return (
        <Button
            type={isSubscribed ? "flat" : "outlined"}
            onClick={handleClick}
            isDisabled={isButtonDisabled}
            data-automation="alerts-subscribe-button"
        >
            <Tooltip
                content={translate("activation.alerts.subscribe.tooltip")}
                enabled={isSubscribed}
            >
                <Text
                    fontVariant="button"
                    color={colorsPalettes.blue[500]}
                    display="flex"
                    gap="4px"
                    alignItems="center"
                >
                    {isSubscribed ? (
                        <Check
                            size={16}
                            color={colorsPalettes.blue[400]}
                        />
                    ) : (
                        <SocialEmail
                            size={16}
                            color={colorsPalettes.blue[400]}
                        />
                    )}
                    {translate(isSubscribed ? "common.subscribed" : "common.subscribe")}
                </Text>
            </Tooltip>
        </Button>
    );
};
